module.exports = __webpack_public_path__ + "img/map-marker.705838c.png";